<template>
  <loader
    v-show="commonStore.loader"
    name="dots"
    object="#d2b88f"
    size="5"
    speed="2"
    bg="#343a40"
    objectbg="#999793"
    opacity="20"
    :disableScrolling="false"
  ></loader>
  <header-box-4
    v-if="enabledStore.portalTypeBooks !== null"
    :bookPortal="enabledStore.portalTypeBooks"
  ></header-box-4>
  <main :class="pageClass">
    <div class="container">
      <router-view @updatePageClass="handlePageClass"></router-view>
    </div>
  </main>
  <footer-box-4></footer-box-4>
</template>

<script>
  import { useAuthStore, useCommonStore, useEnabledStore } from '@/stores';
  import { RouterView } from 'vue-router';
  import HeaderBox4 from './components/layouts/header/HeaderBox4.vue';
  import FooterBox4 from './components/layouts/footer/FooterBox4.vue';

  export default {
    components: {
      RouterView,
      HeaderBox4,
      FooterBox4,
    },
    data() {
      return {
        pageClass: '',
        commonStore: useCommonStore(),
        authStore: useAuthStore(),
        enabledStore: useEnabledStore(),
      };
    },
    watch: {
      $route(to, from) {
        this.pageClass = '';
      },
    },
    methods: {
      handlePageClass(newClass) {
        this.pageClass = newClass;
      },
      async checkPortalType() {
        this.enabledStore.checkPortalType();
      },
    },
    created() {
      this.checkPortalType();
    },
    computed: {
      isAuth() {
        return this.authStore.isAuth;
      },
      isPortalTypeBooks() {
        return this.enabledStore.isPortalTypeBooks;
      },
    },
  };
</script>
